import { GridColumnExtraSettings, GridColumnSettings } from '@/shared/types/grid';

import { TextAlign } from '@syncfusion/ej2-grids';

export const textColumn = <T>(options: {
  uid?: string;
  field: keyof T & string;
  header?: string;
  headerTemplate?: string;
  template?: string | ((data: T) => string);
  emptyText?: string;
  emptyClass?: string;
  textAlign?: TextAlign;
  minWidth?: number;
  allowFiltering?: boolean;
  allowSorting?: boolean;
  width?: number;
  visible?: boolean;
  showInColumnChooser?: boolean;
  extra?: GridColumnExtraSettings<T>;
}): GridColumnSettings<T> => {
  const {
    uid,
    field,
    header,
    headerTemplate,
    emptyText = 'Not set',
    emptyClass = 'text-more-muted',
    template,
    textAlign,
    minWidth,
    allowFiltering,
    allowSorting,
    width,
    visible,
    showInColumnChooser,
    extra,
  } = options ?? {};

  const displayField = extra?.displayField ?? field;

  return {
    uid: uid ?? field,
    field,
    headerText: header ?? '',
    headerTemplate,
    type: 'string',
    clipMode: 'EllipsisWithTooltip',
    textAlign,
    minWidth,
    ...(emptyText
      ? {
          template: `\${if(${field} === 0 || ${field})}\${${displayField}}\${else}<span class="${
            emptyClass ?? ''
          }">${emptyText}</span>\${/if}`,
        }
      : {
          template: `\${${displayField}}`,
        }),
    ...(template ? { template } : {}),
    allowFiltering: allowFiltering ?? true,
    allowSorting: allowSorting ?? true,
    width: width ?? 150,
    visible: visible ?? true,
    showInColumnChooser: showInColumnChooser ?? true,
    toolTip: '',
    extra,
  };
};
